import { EntityModel } from 'src/core/services/data/models';
import { DataService, property } from 'src/core/services/data.service';
import { BookemZulu as Model } from 'src/core/services/data/JayDataContext';

export class SellMarginPolicyDataService extends DataService<typeof Model.Bookings.Logic.ViewModels.SellMarginPolicyItem, Model.Bookings.Logic.ViewModels.SellMarginPolicyItem, SellMarginPolicyItem> {
	protected map(entity: Model.Bookings.Logic.ViewModels.SellMarginPolicyItem): SellMarginPolicyItem {
		return new SellMarginPolicyItemModel(entity);
	}

	static make(ctx?: any): SellMarginPolicyDataService {
		return new SellMarginPolicyDataService(ctx, ctx => ctx.SellMarginPolicies);
	}

	add(defaultLanguage: string): Promise<SellMarginPolicyItem> {
		const entity = new Model.Bookings.Logic.ViewModels.SellMarginPolicyItem();
		(entity as any).dynamicProperties = {
			displayName: {
				[defaultLanguage]: ''
			}
		};
		entity.priority = 0;

		return this.create(() => entity);
	}
}

export class SellMarginPolicyItemModel extends EntityModel<Model.Bookings.Logic.ViewModels.SellMarginPolicyItem, SellMarginPolicyItem> implements SellMarginPolicyItem {
	@property<SellMarginPolicyItemModel>(o => o.entity.id, (o, value) => o.entity.id = value)
	public id: number;

	@property<SellMarginPolicyItemModel>(o => o.entity.isActive, (o, value) => o.entity.isActive = value)
	public isActive: boolean;

	@property<SellMarginPolicyItemModel>(o => parseFloat(o.entity.margin.toString()), (o, value) => o.entity.margin = value)
	public margin: number;

	@property<SellMarginPolicyItemModel>(o => o.entity.priceRoundingType, (o, value) => o.entity.priceRoundingType = value)
	public priceRoundingType: number;

	@property<SellMarginPolicyItemModel>(o => o.entity.priority, (o, value) => o.entity.priority = value)
	public priority: number;

	@property<any>(o => o.entity.dynamicProperties, (o, value) => o.entity.dynamicProperties = value)
	public dynamicProperties: any;

	@property<SellMarginPolicyItemModel>(o => o.entity.rules, (o, value) => o.entity.rules = value)
	public rules: PolicyRuleItem[];
}



// WEBPACK FOOTER //
// ./src/app/bookings/sell-margin-policies/form/sell-margin-policy-form.data.ts